/* eslint-disable prettier/prettier */
import bubble from "./bubble";

// const install = function(Vue) {
//   Vue.directive("bubble", bubble);
// };
// bubble.install = install;
export default {
  install: function (Vue) {
    Vue.directive("bubble", bubble);
  }
};
